import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { FaFacebook, FaTwitter, FaInstagram } from 'react-icons/fa';

function Footer() {
  const { t } = useTranslation();
  return (
    <footer id="colophon" className="site-footer" style={{
      background: 'linear-gradient(135deg, var(--color-warm-cream) 0%, rgba(239, 202, 187, 0.3) 100%)',
      borderRadius: '30px 30px 0 0'
    }}>
      <div className="site-bottom">
        <div style={{
          maxWidth: '1200px',
          margin: '0 auto',
          padding: 'var(--spacing-6) var(--spacing-4)',
          display: 'grid',
          gridTemplateColumns: 'repeat(4, 1fr)',
          gap: 'var(--spacing-4)'
        }}>
          {/* Colonne 1 - Logo et description */}
          <div>
            <div style={{ marginBottom: 'var(--spacing-3)' }}>
              <Link to="/" rel="home" style={{ textDecoration: 'none', display: 'inline-block' }}>
                <img 
                  src="/logo.png" 
                  alt="RIVE Accueil - Accueil de jour pour femmes et enfants" 
                  style={{
                    height: '60px',
                    width: 'auto',
                    maxWidth: '150px',
                    objectFit: 'contain'
                  }}
                />
              </Link>
            </div>
            <p style={{
              fontSize: 'var(--font-size-xs)',
              color: 'var(--color-dark)',
              lineHeight: '1.6',
              marginBottom: 'var(--spacing-3)',
              fontFamily: 'var(--font-body)'
            }}>
              {t('footer.welcome')}
            </p>
            <div style={{ display: 'flex', gap: 'var(--spacing-4)' }}>
              <div style={{
                width: '36px',
                height: '36px',
                background: 'rgba(37, 76, 66, 0.1)',
                borderRadius: '50%',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                cursor: 'pointer',
                transition: 'all 0.3s ease'
              }}>
                <FaFacebook style={{ fontSize: '1.2rem', color: 'var(--color-green-dark)' }} />
              </div>
              <div style={{
                width: '36px',
                height: '36px',
                background: 'rgba(37, 76, 66, 0.1)',
                borderRadius: '50%',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                cursor: 'pointer',
                transition: 'all 0.3s ease'
              }}>
                <FaTwitter style={{ fontSize: '1.2rem', color: 'var(--color-green-dark)' }} />
              </div>
              <div style={{
                width: '36px',
                height: '36px',
                background: 'rgba(37, 76, 66, 0.1)',
                borderRadius: '50%',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                cursor: 'pointer',
                transition: 'all 0.3s ease'
              }}>
                <FaInstagram style={{ fontSize: '1.2rem', color: 'var(--color-green-dark)' }} />
              </div>
            </div>
          </div>

          {/* Colonne 2 - Menu */}
          <div>
            <h3 style={{
              fontSize: 'var(--font-size-sm)',
              fontWeight: 700,
              color: 'var(--color-green-dark)',
              marginBottom: 'var(--spacing-2)'
            }}>
              {t('footer.menu')}
            </h3>
            <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
              {[
                { to: '/', label: t('header.home') },
                { to: '/notre-histoire', label: t('header.ourStory') },
                { to: '/nos-actions', label: t('header.ourActions') },
                { to: '/donations', label: t('header.donate') },
                { to: '/renseignements-pratiques', label: t('footer.contact') }
              ].map((item) => (
                <li key={item.to} style={{ marginBottom: 'var(--spacing-2)' }}>
                  <Link to={item.to} style={{
                    color: 'var(--color-dark)',
                    textDecoration: 'none',
                    fontSize: 'var(--font-size-sm)',
                    transition: 'color var(--transition-base)'
                  }}>
                    {item.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Colonne 3 - Services */}
          <div>
            <h3 style={{
              fontSize: 'var(--font-size-sm)',
              fontWeight: 700,
              color: 'var(--color-green-dark)',
              marginBottom: 'var(--spacing-2)'
            }}>
              {t('footer.services')}
            </h3>
            <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
              {[t('footer.service1'), t('footer.service2'), t('footer.service3'), t('footer.service4')].map((service) => (
                <li key={service} style={{ marginBottom: 'var(--spacing-2)' }}>
                  <Link to="/nos-actions" style={{
                    color: 'var(--color-dark)',
                    textDecoration: 'none',
                    fontSize: 'var(--font-size-sm)',
                    transition: 'color var(--transition-base)'
                  }}>
                    {service}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Colonne 4 - Contact */}
          <div>
            <h3 style={{
              fontSize: 'var(--font-size-sm)',
              fontWeight: 700,
              color: 'var(--color-green-dark)',
              marginBottom: 'var(--spacing-2)'
            }}>
              {t('footer.contact')}
            </h3>
            <div style={{
              fontSize: 'var(--font-size-sm)',
              color: 'var(--color-dark)',
              lineHeight: '1.8'
            }}>
              <div style={{ marginBottom: 'var(--spacing-2)' }}>
                8 bis rue Monseigneur Gibier<br />
                Versailles, France
              </div>
              <div style={{ marginBottom: 'var(--spacing-2)' }}>
                01 30 21 34 50
              </div>
              <div>
                info@rive-accueil.fr
              </div>
            </div>
          </div>
        </div>

        <div style={{
          maxWidth: '1200px',
          margin: '0 auto',
          padding: 'var(--spacing-3) var(--spacing-4)',
          borderTop: '1px solid rgba(37, 76, 66, 0.15)',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          fontSize: 'var(--font-size-xs)',
          color: 'var(--color-dark)'
        }}>
          <div>
            {t('footer.copyright', { year: new Date().getFullYear() })}
          </div>
          <div>
            <Link to="/admin/login" style={{
              color: 'var(--color-dark)',
              textDecoration: 'none',
              opacity: 0.5,
              fontSize: 'var(--font-size-xs)',
              transition: 'opacity 0.3s ease'
            }}
            onMouseEnter={e => e.currentTarget.style.opacity = '1'}
            onMouseLeave={e => e.currentTarget.style.opacity = '0.5'}
            >
              Administration
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
